import {AuthModalVariant} from "../../auth/components/auth_modal/AuthModalHeaderVariants";
import {startRegistrationFlow} from "../../auth/state/registration_flow_slice";
import {useShouldHidePrices} from "../../hooks/use_should_hide_prices";
import {useAppDispatch} from "../../store/hooks";
import {trackAmplitudeButtonClick} from "../../tracking/amplitude/track_amplitude_button_click";
import {UserSource} from "../../tracking/tracking_utils/user_source";
import {AmplitudeAuthPlacement} from "../../tracking/types/AmplitudeAuthPlacement";
import {useGetIsUserAuthenticatedQuery} from "../../user/api/get_is_user_authenticated";
import {openVendorReportModal} from "../state/vendor_detail_slice";
import {hitGTMDeveloperReportClick} from "../tracking/hit_gtm_developer_report";

interface IUseVendorReportButtonOptions {
    propertyId?: number;
    offerId?: number;
    amplitudePlacement?: AmplitudeAuthPlacement;
}

export function useVendorReportButton(vendorId: number, options?: IUseVendorReportButtonOptions) {
    const dispatch = useAppDispatch();
    const {data: isUserAuthenticated} = useGetIsUserAuthenticatedQuery();
    const {hasCompleteProfile, hasPhoneVerified} = useShouldHidePrices();

    const handleClick = () => {
        hitGTMDeveloperReportClick();
        if (options?.offerId != null) {
            trackAmplitudeButtonClick({
                buttonName: "download_developer_report",
                value: "download_developer_report",
                buttonCategory: options?.propertyId ? "property_page" : "investment_page",
                itemId: options.offerId,
                propertyId: options?.propertyId
            });
        }
        if (hasPhoneVerified) {
            dispatch(openVendorReportModal({vendorId}));
        } else {
            dispatch(
                startRegistrationFlow({
                    isUserLoggedIn: isUserAuthenticated,
                    hasCompleteProfile,
                    hasPhoneVerified,
                    userSource: UserSource.VENDOR_REPORT_BUTTON,
                    titleVariant: AuthModalVariant.DOWNLOAD_REPORT,
                    gtmSourceSection: "Rejestracja z przycisku pobrania raportu o deweloperze",
                    propertyId: options?.propertyId,
                    offerId: options?.offerId,
                    amplitudePlacement: options?.amplitudePlacement
                })
            );
        }
    };

    return {
        handleClick,
        buttonText: "Raport o deweloperze"
    };
}
import {AuthModalVariant} from "../../auth/components/auth_modal/AuthModalHeaderVariants";
import {startRegistrationFlow} from "../../auth/state/registration_flow_slice";
import {useShouldHidePrices} from "../../hooks/use_should_hide_prices";
import {useAppDispatch} from "../../store/hooks";
import {trackAmplitudeButtonClick} from "../../tracking/amplitude/track_amplitude_button_click";
import {UserSource} from "../../tracking/tracking_utils/user_source";
import {AmplitudeAuthPlacement} from "../../tracking/types/AmplitudeAuthPlacement";
import {useGetIsUserAuthenticatedQuery} from "../../user/api/get_is_user_authenticated";
import {openVendorReportModal} from "../state/vendor_detail_slice";
import {hitGTMDeveloperReportClick} from "../tracking/hit_gtm_developer_report";

interface IUseVendorReportButtonOptions {
    propertyId?: number;
    offerId?: number;
    amplitudePlacement?: AmplitudeAuthPlacement;
}

export function useVendorReportButton(vendorId: number, options?: IUseVendorReportButtonOptions) {
    const dispatch = useAppDispatch();
    const {data: isUserAuthenticated} = useGetIsUserAuthenticatedQuery();
    const {hasCompleteProfile, hasPhoneVerified} = useShouldHidePrices();

    const handleClick = () => {
        hitGTMDeveloperReportClick();
        if (options?.offerId != null) {
            trackAmplitudeButtonClick({
                buttonName: "download_developer_report",
                value: "download_developer_report",
                buttonCategory: options?.propertyId ? "property_page" : "investment_page",
                itemId: options.offerId,
                propertyId: options?.propertyId
            });
        }
        if (hasPhoneVerified) {
            dispatch(openVendorReportModal({vendorId}));
        } else {
            dispatch(
                startRegistrationFlow({
                    isUserLoggedIn: isUserAuthenticated,
                    hasCompleteProfile,
                    hasPhoneVerified,
                    userSource: UserSource.VENDOR_REPORT_BUTTON,
                    titleVariant: AuthModalVariant.DOWNLOAD_REPORT,
                    gtmSourceSection: "Rejestracja z przycisku pobrania raportu o deweloperze",
                    propertyId: options?.propertyId,
                    offerId: options?.offerId,
                    amplitudePlacement: options?.amplitudePlacement
                })
            );
        }
    };

    return {
        handleClick,
        buttonText: "Raport o deweloperze"
    };
}
